/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var dateRangePickerPanelProps = {
  onCellClick: Function,
  onChange: Function,
  onConfirm: Function,
  onMonthChange: Function,
  onPanelClick: Function,
  onPresetClick: Function,
  onTimeChange: Function,
  onYearChange: Function
};

export { dateRangePickerPanelProps as default };
//# sourceMappingURL=date-range-picker-panel-props.mjs.map
